"use client";
import { JSX } from "react";
import { EditingScripts } from "@sitecore-content-sdk/nextjs";
import CdpPageView from "components/content-sdk/CdpPageView";
import ChatbotScripts from "components/Chatbot/ChatbotScripts";
import ApmInitScript from "components/elastic-search/ApmProvider";
import { SalesforceInteractionsScripts } from "components/Salesforce/SalesforceInteractionsScripts";
import { SpeedInsights } from "@vercel/speed-insights/next";
import ReferringUrlScript from "components/Forms/FormReferringUrl";

const Scripts = (): JSX.Element => {
  const vercelSpeedInsights =
    process.env.NEXT_PUBLIC_VERCEL_SPEEDINSIGHTS_ENABLED === "true";
  return (
    <>
      <CdpPageView />
      <EditingScripts />
      <SalesforceInteractionsScripts />
      {vercelSpeedInsights && <SpeedInsights />}
      <ChatbotScripts />
      <ReferringUrlScript />
      <ApmInitScript />
    </>
  );
};

export default Scripts;
